var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawDataReportReP4So1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1202,
    viewBox: "0 0 1440 1202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_data_report_re_p4so 1",
    clipPath: "url(#clip0_406_3309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M1665.86 1289.67L314.965 1754.14L-86.8031 585.625L1264.09 121.152L1665.86 1289.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.2,
    d: "M1665.86 1289.67L314.965 1754.14L-86.8031 585.625L1264.09 121.152L1665.86 1289.67ZM327.213 1724.85L1638.19 1274.1L1251.84 150.442L-59.1326 601.19L327.213 1724.85Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.2,
    d: "M569.602 1344.9L467.323 1380.07C464.553 1381.02 461.472 1380.69 458.757 1379.17C456.042 1377.64 453.914 1375.04 452.841 1371.93L398.369 1213.5C397.303 1210.38 397.379 1207.02 398.58 1204.15C399.782 1201.27 402.012 1199.12 404.78 1198.17L507.059 1163C509.83 1162.05 512.911 1162.38 515.626 1163.91C518.341 1165.43 520.468 1168.04 521.542 1171.15L576.013 1329.58C577.08 1332.69 577.004 1336.05 575.802 1338.92C574.6 1341.8 572.371 1343.95 569.602 1344.9Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.2,
    d: "M756.121 1280.77L653.842 1315.94C651.071 1316.89 647.99 1316.56 645.275 1315.04C642.56 1313.51 640.432 1310.91 639.359 1307.79L533.222 999.1C532.155 995.987 532.231 992.625 533.433 989.751C534.635 986.877 536.864 984.727 539.633 983.771L641.912 948.605C644.682 947.656 647.763 947.981 650.478 949.508C653.193 951.035 655.321 953.64 656.394 956.75L762.532 1265.44C763.598 1268.56 763.522 1271.92 762.321 1274.79C761.119 1277.67 758.889 1279.82 756.121 1280.77Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M942.639 1216.64L840.36 1251.81C837.589 1252.76 834.508 1252.43 831.793 1250.91C829.078 1249.38 826.951 1246.78 825.877 1243.67L771.406 1085.24C770.339 1082.12 770.415 1078.76 771.617 1075.89C772.819 1073.01 775.049 1070.86 777.817 1069.91L880.096 1034.74C882.867 1033.79 885.947 1034.12 888.662 1035.65C891.378 1037.17 893.505 1039.78 894.578 1042.89L949.05 1201.32C950.117 1204.43 950.041 1207.79 948.839 1210.66C947.637 1213.54 945.407 1215.69 942.639 1216.64Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M1129.16 1152.51L1026.88 1187.68C1024.19 1188.68 1021.18 1188.43 1018.5 1187.01C1015.82 1185.58 1013.69 1183.08 1012.58 1180.07L885.681 810.993C884.703 807.929 884.848 804.651 886.084 801.877C887.319 799.103 889.546 797.06 892.275 796.195L994.554 761.029C997.238 760.033 1000.25 760.275 1002.93 761.702C1005.61 763.129 1007.74 765.625 1008.85 768.643L1135.75 1137.72C1136.73 1140.78 1136.58 1144.06 1135.35 1146.83C1134.11 1149.61 1131.89 1151.65 1129.16 1152.51Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M1315.68 1088.38L1213.4 1123.55C1210.63 1124.5 1207.54 1124.17 1204.83 1122.65C1202.11 1121.12 1199.99 1118.52 1198.91 1115.4L1035.67 640.626C1034.61 637.512 1034.68 634.15 1035.88 631.276C1037.08 628.402 1039.31 626.252 1042.08 625.296L1144.36 590.13C1147.13 589.181 1150.21 589.506 1152.93 591.033C1155.64 592.56 1157.77 595.165 1158.84 598.276L1322.09 1073.05C1323.15 1076.17 1323.08 1079.53 1321.88 1082.4C1320.67 1085.28 1318.44 1087.43 1315.68 1088.38Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.2,
    d: "M439.604 1133.13C451.266 1129.12 457.067 1115.25 452.562 1102.15C448.056 1089.04 434.95 1081.67 423.289 1085.68C411.627 1089.69 405.826 1103.56 410.331 1116.67C414.837 1129.77 427.943 1137.14 439.604 1133.13Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.2,
    d: "M573.097 914.781C584.759 910.771 590.56 896.898 586.055 883.794C581.549 870.69 568.443 863.318 556.781 867.328C545.12 871.337 539.319 885.21 543.824 898.314C548.329 911.418 561.435 918.79 573.097 914.781Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.2,
    d: "M812.641 1004.87C824.303 1000.86 830.104 986.99 825.598 973.886C821.093 960.782 807.987 953.41 796.325 957.419C784.664 961.429 778.862 975.302 783.368 988.406C787.873 1001.51 800.979 1008.88 812.641 1004.87Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.2,
    d: "M920.301 711.387C931.962 707.377 937.763 693.504 933.258 680.4C928.753 667.297 915.647 659.924 903.985 663.934C892.323 667.944 886.522 681.817 891.028 694.92C895.533 708.024 908.639 715.396 920.301 711.387Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.2,
    d: "M1076.91 560.26C1088.57 556.25 1094.37 542.377 1089.86 529.274C1085.36 516.17 1072.25 508.798 1060.59 512.807C1048.93 516.817 1043.13 530.69 1047.63 543.794C1052.14 556.897 1065.25 564.27 1076.91 560.26Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.2,
    d: "M806.757 986.307L565.689 893.237L434.646 1111.84L428.249 1106.97L562.291 883.354L802.21 975.984L908.94 685.036L909.566 684.443L1067.05 535.869L1072.2 542.302L915.345 690.283L806.757 986.307Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.2,
    d: "M1364.97 1113.77L1262.69 1148.93C1259.92 1149.88 1256.84 1149.56 1254.13 1148.03C1251.41 1146.5 1249.28 1143.9 1248.21 1140.79L1084.97 666.006C1083.9 662.893 1083.98 659.531 1085.18 656.657C1086.38 653.783 1088.61 651.632 1091.38 650.676L1193.66 615.51C1196.43 614.561 1199.51 614.886 1202.22 616.413C1204.94 617.94 1207.07 620.545 1208.14 623.656L1371.38 1098.44C1372.45 1101.55 1372.37 1104.91 1371.17 1107.78C1369.97 1110.66 1367.74 1112.81 1364.97 1113.77Z",
    fill: "#6C63FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_3309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1801.12,
    height: 1518.95,
    fill: "white",
    transform: "translate(-86.8031 585.625) rotate(-18.9743)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawDataReportReP4So1);
export default __webpack_public_path__ + "static/media/undraw_data_report_re_p4so 1.2b99101587e640d165be9736d151d0b7.svg";
export { ForwardRef as ReactComponent };